module.exports = __webpack_public_path__ + "img/jp.c912519d.png";